import * as React from 'react';

import { Navbar, NavbarToggler, NavbarBrand } from 'reactstrap';

import './Header.scss';
import { getAppContext } from '~/lib/AppContext';

// This markup is mirrored by the pre-mount skeleton in
// Views/Shared/PanelPage.cshtml — keep both in sync.
class Header extends React.Component {
    render() {
        return (
            <Navbar dark={true} fixed="top" className="flex-row bl-top-navbar bg-dark" expand={true}>
                <NavbarToggler id="toggle-sidenav" className="d-block me-2" />
                <NavbarBrand href="/" className="ms-auto">
                    <img
                        src={`/img/logo-${getAppContext().config.theme.toLowerCase()}.png`}
                        alt={getAppContext().config.brandName}
                    />
                </NavbarBrand>
            </Navbar>
        );
    }
}

export default Header;
